export default __webpack_public_path__ + "static/media/about.55309319.mp4";